import React, { useRef, useEffect, useState } from 'react';

const BeratSVG = ({ beratSvg, ArcelikImg, YetkiliServisImg, BekoImg, txtHeader, SessionUser, textStyle1, textStyle2, textStyle3 }) => {
  const svgWidth = 1286;
  const svgHeight = 909;
  const viewBox = `0 0 ${svgWidth} ${svgHeight}`;

  const [textX, setTextX] = useState(svgWidth / 2); // Varsayılan olarak ortala
  const textRef = useRef(null);

  useEffect(() => {
    if (textRef.current) {
      const textWidth = textRef.current.getBBox().width;
      setTextX((svgWidth - textWidth) / 2); // Metni tam ortalamak için x koordinatını hesapla
    }
  }, [SessionUser]);

  const headerX = 350 / svgWidth * 100;
  const calisaniX = 520 / svgWidth * 100;
  const textY1 = 230 / svgHeight * 100;
  const textY2 = 300 / svgHeight * 100;
  const textY3 = 370 / svgHeight * 100;
  const textX1 = 310 / svgWidth * 100;
  const textX2 = 300 / svgWidth * 100;
  const textX3 = 400 / svgWidth * 100;
  const textY4 = 480 / svgHeight * 100;
  const textY5 = 510 / svgHeight * 100;
  const textY6 = 540 / svgHeight * 100;
  const textX4 = 500 / svgWidth * 100;
  const textX5 = 440 / svgWidth * 100;
  const textY7 = 660 / svgHeight * 100;
  const textY8 = 690 / svgHeight * 100;
  const arcelikX = 420 / svgWidth * 100;
  const yetkiliX = 590 / svgWidth * 100;
  const bekoX = 840 / svgWidth * 100;
  const arcelikY = 740 / svgHeight * 100;
  const yetkiliY = 660 / svgHeight * 100;
  const bekoY = 740 / svgHeight * 100;

  return (
    <svg 
      style={{ width: '100%', height: 'auto' }} 
      viewBox={viewBox} 
      preserveAspectRatio="xMidYMid meet" 
      xmlns="http://www.w3.org/2000/svg"
    >
      <image href={beratSvg} width="100%" height="100%" />
      <text x={`${headerX}%`} y={`${textY1}%`} style={textStyle1}>
        {txtHeader}
      </text>
      <text x={`${calisaniX}%`} y={`${textY2}%`} style={textStyle1}>
        Çalışanı,
      </text>
      <text x={textX} y={`${textY3}%`} style={textStyle1} ref={textRef}>
        {SessionUser.FirstName + ' ' + SessionUser.LastName}
      </text>
      <text x={`${textX1}%`} y={`${textY4}%`} style={textStyle2}>
        Meslek hayatınızda uzun yıllar boyunca gösterdiğiniz özveri ve
      </text>
      <text x={`${textX2}%`} y={`${textY5}%`} style={textStyle2}>
        müşteri memnuniyetine yönelik başarılı çalışmalarınızdan dolayı
      </text>
      <text x={`${textX3}%`} y={`${textY6}%`} style={textStyle2}>
        teşekkür eder, başarılarınızın devamını dileriz.
      </text>
      <text x={`${textX4}%`} y={`${textY7}%`} style={textStyle3}>
        Arçelik Pazarlama A.Ş.
      </text>
      <text x={`${textX5}%`} y={`${textY8}%`} style={textStyle3}>
        Müşteri Hizmetleri Direktörlüğü
      </text>
      <image href={ArcelikImg} x={`${arcelikX}%`} y={`${arcelikY}%`} />
      <image href={YetkiliServisImg} x={`${yetkiliX}%`} y={`${yetkiliY}%`} />
      <image href={BekoImg} x={`${bekoX}%`} y={`${bekoY}%`} />
    </svg>
  );
};

export default BeratSVG;
